import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { purchase } from 'components/graphql/queries'
import { stripUriParamsString } from 'lib/utils/helpers';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom';

const PaymentConfirmation: React.FC<{ [label: string]: any }> = (props: any) => {

    const n: any = stripUriParamsString(props.match.params.name)
    const parsedName: any = n.split('SPACE').join(' ')

    const [name] = useState(parsedName)
    const [email] = useState(stripUriParamsString(props.match.params.email))
    const [phoneNumber] = useState(stripUriParamsString(props.match.params.phoneNumber))
    const [code] = useState(stripUriParamsString(props.match.params.code))
    const [campaignId] = useState(stripUriParamsString(props.match.params.campaignId))
    const [sellerId] = useState(stripUriParamsString(props.match.params.sellerId))

    const params = queryString.parse(props.location.search)
    console.log(params)
    const [sessionId] = useState(params.session_id)
    console.log(sessionId)

    const parsedOrderComponets: any[] = []
    const unparsedOrderComponets: any = stripUriParamsString(props.match.params.orderComponents)
    const preParsedOrderComponents: any = unparsedOrderComponets.split('-')
    preParsedOrderComponents.map(item => {
        const newObj = {}
        const items = item.split('&')
        items.map((i) => {
            const key = i.split('=')[0]
            const val = i.split('=')[1]
            newObj[key] = (key === 'count' || key === 'validated') ? Number(val) : val
        })
        parsedOrderComponets.push(newObj)
    })
    console.log(parsedOrderComponets)
    const [orderComponents] = useState(parsedOrderComponets)

    const [floorplanLocationX] = useState(stripUriParamsString(props.match.params.floorplanLocationX))
    const [floorplanLocationY] = useState(stripUriParamsString(props.match.params.floorplanLocationY))
    const [address] = useState(stripUriParamsString(props.match.params.address))

    useEffect(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: purchase,
                variables: {
                    name,
                    email,
                    phoneNumber,
                    code,
                    campaignId,
                    sellerId,
                    orderComponents,
                    floorplanLocationX: floorplanLocationX === 'NULL' ? null : floorplanLocationX,
                    floorplanLocationY: floorplanLocationY === 'NULL' ? null : floorplanLocationY,
                    address: address === 'NULL' ? null : address,
                    sessionId
                }
            })
            .then(res => {
                if (res.data.data.order.purchase !== 'Purchase-Error') {
                    window.location.pathname = '/receipt/' + code
                }
            })
            .catch(err => {
                console.log(err)
            })
    }, [name, email, phoneNumber, code, campaignId, sellerId, orderComponents, floorplanLocationX, floorplanLocationY, address])

    return null

}


export default withRouter(PaymentConfirmation);


// WEBPACK FOOTER //
// ./src/components/confirmTransaction/PaymentConfirmation.tsx